// SplitEdge Modal Window

(($) => {

    const currencyFormat = new Intl.NumberFormat('en-US', {
        style: 'currency', 
        currency: 'USD',
        maximumFractionDigits: 0,
    });

    //handle upfront dollar amount
    $('#upfront-dollar-amount').on('keydown input', function() {
        if($('#upfront-dollar-amount').val().length < 10) {
            var enteredValue = $('#upfront-dollar-amount').val().replace(',','').replace('$', '');
            console.log(enteredValue);
            $('#upfront-dollar-amount').val(currencyFormat.format(enteredValue));
        }
    });

    //handle monthly dollar amount
    $('#monthly-dollar-amount').on('keydown input', function() {
        if($('#monthly-dollar-amount').val().length < 10) {
            var enteredValue = $('#monthly-dollar-amount').val().replace(',','').replace('$', '');
            $('#monthly-dollar-amount').val(currencyFormat.format(enteredValue));
        }
    });

    //handle upfront or mothly selection
    $('#upfront-dollar-amount').click( function() {
        $('#monthly-dollar-amount').val('');
        $('#upfront-dollar-amount-container').addClass('highlight');
        $('#upfront-dollar-amount-container').removeClass('non-highlight');
        $('#monthly-dollar-amount-container').addClass('non-highlight');
        $('#monthly-dollar-amount-container').removeClass('highlight');
    });
    
    $('#monthly-dollar-amount').click( function() {
        $('#upfront-dollar-amount').val('');
        $('#upfront-dollar-amount-container').addClass('non-highlight');
        $('#upfront-dollar-amount-container').removeClass('highlight');
        $('#monthly-dollar-amount-container').addClass('highlight');
        $('#monthly-dollar-amount-container').removeClass('non-highlight');
    });

    //handle table row selection
    $('#rate-table-body tr').click(function() {
        $(this).addClass('selected').siblings().removeClass('selected');
    });

    //handle click submission & get select table row value
    $('#submit-rate-button').on('click', function(e) {
        alert("Row selected: " + $('#rate-table-body tr.selected td:first').html());
        return false;
    });

})(jQuery);
